import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AdminManagement from "./pages/AdminManagement";
import FeaturePage from "./pages/FeaturePage";
import NetworkManagement from "./pages/NetworkManagement";
import ChangePassword from "./pages/ChangePassword";
import CatalogManagement from "./pages/CatalogManagement";
import SalesPersonManagement from "./pages/SalesPersonManagement";
import DistributorOrders from "./pages/DistributorOrders";
import InstallApp from "./components/InstallApp";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/install" element={<InstallApp />} />
          <Route path="/login" element={<Login />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admins"
            element={
              <ProtectedRoute requireSuperAdmin>
                <AdminManagement />
              </ProtectedRoute>
            }
          />

          <Route
            path="/network/states"
            element={
              <ProtectedRoute requirePermission="manage_states">
                <NetworkManagement resource="states" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/network/districts"
            element={
              <ProtectedRoute requirePermission="manage_districts">
                <NetworkManagement resource="districts" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/network/distributors"
            element={
              <ProtectedRoute requirePermission="manage_distributors">
                <NetworkManagement resource="distributors" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/network/salespersons"
            element={
              <ProtectedRoute requirePermission="manage_salespersons">
                <SalesPersonManagement />
              </ProtectedRoute>
            }
          />

          <Route
            path="/users"
            element={
              <ProtectedRoute requirePermission="view_users">
                <FeaturePage title="Users" endpoint="/features/users" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute requirePermission="view_orders">
                <DistributorOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute requirePermission="view_reports">
                <FeaturePage title="Reports" endpoint="/features/reports" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/content"
            element={
              <ProtectedRoute requirePermission="manage_content">
                <FeaturePage title="Content" endpoint="/features/content" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute requirePermission="manage_settings">
                <FeaturePage title="Settings" endpoint="/features/settings" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />
          <Route path="/catalog/categories" element={<ProtectedRoute requireAnyPermission={["view_products", "manage_products"]}><CatalogManagement resource="categories" /></ProtectedRoute>} />
          <Route path="/catalog/subcategories" element={<ProtectedRoute requireAnyPermission={["view_products", "manage_products"]}><CatalogManagement resource="subcategories" /></ProtectedRoute>} />
          <Route path="/catalog/products" element={<ProtectedRoute requireAnyPermission={["view_products", "manage_products"]}><CatalogManagement resource="products" /></ProtectedRoute>} />

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
